<template>
    <div class="modal fade" id="unidade_search_modal" data-backdrop="static">
        <div class="modal demo-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <b>Filtrar</b>
                        </h5>
                    </div>
                    <div class="modal-body"> 

                        <dot :isVisible="isLoading"></dot>

                        <div v-if="!isLoading">

                            <div class="form-group">
                                <label class="col-form-label">Nome:</label>
                                <input type="text" placeholder="Nome da Unidade " v-model="nome_search" class="form-control">
                            </div>

                            <div class="form-group">
                                <label class="col-form-label" for="title">Órgãos: *</label>
                                <basic-select :options="orgaos"
                                        :selected-option="orgao"
                                        placeholder="Selecione o Órgão"
                                        @select="onSelectOrgao">
                                </basic-select>
                            </div>

                        </div>

                    </div>
                    <div class="modal-footer">
                    	<div 
	                        v-if="(this.nome_search.length > 0 || 	                        
	                        this.orgao_id_search > 0 )">
	                        <button type="button" @click.prevent.stop="limparFiltros" class="btn btn-danger pull-left">
	                            Limpar Filtros
	                        </button>
	                    </div>
                        <button type="button" class="btn btn-light" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success"
                            @click.prevent.stop="filterUnidades">
                            Filtrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	import { eventBus } from '../../app';
    import Dot from '../loadder/Dot.vue';
    import { TheMask } from 'vue-the-mask';
    import { BasicSelect } from 'vue-search-select';

    export default {

    	components: {
            Dot,
            TheMask,
            BasicSelect
        },


    	data(){
            return {
                configDateMask: {
                    maskedValue: false
                },
            	isLoading: false,

                //ARRAYS
            	filtros: [],
                orgaos: [],

                //OBJECTS
                orgao: {},
                nome_search: '',
                cnpj_search: '',
                orgao_id_search: null
            }
        },

        mounted(){
        	this.registryEventOpenModalSearchUnidade();
        },

        methods: {
            registryEventOpenModalSearchUnidade(){
                eventBus.$on('eventOpenModalSearchUnidade', (filtrosParam) => {
                	this.filtros = filtrosParam;
                    this.checkClearFiltersForm();
                    this.getOrgaos();
                    $("#unidade_search_modal").modal("show");
                });
            },

            //EMIT EVENTS
            emitEventGetUnidadesFilter(){
                eventBus.$emit('eventGetUnidadesFilter', 
                    this.filtros
                );
            },
            //FIM EMIT EVENTS

            checkClearFiltersForm(){
                if(this.filtros.length == 0){
                    this.clearFiltros();
                }
            },

            clearFiltros(){
                this.filtros = [];
                this.orgao = {};
                this.nome_search = '';
                this.orgao_id_search = null;
            },

            limparFiltros(){
                this.clearFiltros();
                this.filterUnidades();
            },

            //OUTROS METODOS
            onSelectOrgao(item) {
                this.orgao = item;
                this.orgao_id_search = this.orgao.value;
            },
            //FIM OUTROS METODOS

            filterUnidades(){
                this.filtros = [];
                
                if (this.nome_search.length > 0) {
                    this.filtros.push({ 
                        'property': 'nome',
                        'value': this.nome_search
                    });
                }

                if (this.orgao_id_search > 0) {
                    this.filtros.push({ 
                        'property': 'orgao_id',
                        'value': this.orgao_id_search
                    });
                }

                $("#unidade_search_modal").modal("hide");
                this.emitEventGetUnidadesFilter();
            },
            getOrgaos(){

                var urlOrgaos = '/orgao/combo';
                
                this.isLoading = true;
                
                axios({
                    method: 'GET',
                    url: urlOrgaos
                })
                .then(response => {
                    let me = this;
                    this.isLoading = false;
                    this.orgaos = [];
                    $.each(response.data, function (key, value) {
                        me.orgaos.push({
                            'value': value.id,
                            'text': value.nome
                        });
                    });
                })
                .catch(error => {
                    this.isLoading = false;
                    toastr.error('Falha ao listar órgãos');
                });
            },
        }
    }
</script>